import * as e from "react";
const l = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M18 9.976a1.606 1.606 0 00-.543-1.2l-7.46-6.559a.962.962 0 00-1.57.788.96.96 0 00.301.653l5.764 5.066a.167.167 0 01-.11.292H2.961a.962.962 0 00-.68 1.638c.18.18.425.281.68.281h11.42a.167.167 0 01.11.292l-5.765 5.066a.96.96 0 101.268 1.44l7.462-6.558a1.608 1.608 0 00.544-1.2z",
      fill: "#2D6DED"
    }
  )
), t = l;
export {
  t as default
};
